import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import CopyBox from '../components/bbcode/copybox';

import UploadFile from '../components/upload/upload';
import Blocks from '../components/bbcode/blocks';
import Genres from '../components/genres/genres';
import Socials from '../components/socials/socials';

//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
import { createReactEditorJS } from 'react-editor-js';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
//import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const ReactEditorJS = createReactEditorJS();

//import './css/stream.css';
//import './css/header.css';

class PortalProfile extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
      username: this.props.username,
			account: {},
      levels: [],
      password: {
				text: '',
				valid: false,
				error: '',
				visible: false,
        changed: false,
			},
      genres: {
        show: false, // to show selection
        value: '', // searching
        fulllist: [], // full list of genres
        picker: {}, // selected genres
        picked: [], // selection
      },
      socials: {},
      /*
			genres: {},
			genrelist: {},
			genreshow: false,
			genrepicker: [],
      */
		};
    this.editorInstance = React.createRef();
    this.retreiveAccount = this.retreiveAccount.bind(this);
    this.changeAvatar = this.changeAvatar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitChanges = this.submitChanges.bind(this);
    this.showPassword = this.showPassword.bind(this);
    this.selectGenre = this.selectGenre.bind(this);
		this.removeGenre = this.removeGenre.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );

    const params2 = new URLSearchParams();
		const x = await postApi('/v3/service/prepare', params2);
    //consoleLog("here:", x.data);
    if( x.status === 200 ) {
      let genres = this.state.genres;
      genres.fulllist = x.data.genres;
      this.setState({genres});
    }
		await this.retreiveAccount();
		EventEmitter.emit('/client', '');
		
		
		
	}

	componentWillUnmount() {
    
	}


  async retreiveAccount() {
    const value = this.context;
    let params = new URLSearchParams();
		params.append('username', this.state.username || value.user.user.username);
    params.append('levels', 'true');
		const x = await postApi(`/v3/account/profile`, params);
    if( x.status === 200 ) {
      let genres = this.state.genres;
      genres.picked = x.data.account.genres?.length>0?x.data.account.genres:[];
      this.setState({status: true, account: {}},()=>{
				this.setState({account: x.data.account?x.data.account:{}, levels: x.data.levels?x.data.levels:[], genres, socials: x.data.socials});
			});
    }
  }

  async changeAvatar(name) {
		
    //const user = this.context;
		//let description_temp = this.state.description_temp;
		//description_temp.avatar = name;
		//this.setState({description_temp});
	}


  async handleChange(event) {
    let account = this.state.account;
    let item = event.target.value;

    //---- Account settings
    if( event.target.name === "level" ) account.id_level = parseInt(item);
    if( event.target.name === "email" ) account.email = item;
    if( event.target.name === "pass2" ) {
			const decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,40}$/;
			let password = this.state.password;
			password.text = item;
			password.valid = decimal.test(String(item));
			if( !password.valid ) {
				password.error = 'Requires a Capital, Number and a Special character';
			} else {
				password.error = ''
			}
			if(item.length < 8 || item.length > 40 ) {
				password.valid = false;
				password.error = 'Requires 8 to 40 characters';
			}
      if( password.changed ) password.changed = false;
      this.setState({password});
		}

    //---- Radio
    if( event.target.name === "title" ) account.title = item;
    if( event.target.name === "description" ) account.description = item;
    if( event.target.name === "country" ) {
      if( item.indexOf('/') > 0 ) {
        account.country = item.split('/');
      } else {
        account.country = item;
      }
    }
    
    if( event.target.name === "genre" ) {
      let genres = this.state.genres;
      genres.value = item;
      let _new = {};
      if( item.length >= 4 ) {
        genres.show = true;
        for( let i in this.state.genres.fulllist ) {
          for( let j in this.state.genres.fulllist[i] ) {
            let search = new RegExp(`(${item.replace(' ','|')})`,"gi");
            if( this.state.genres.fulllist[i][j].match(search) != null ) {
              if( !_new[i] ) _new[i] = [];
              _new[i].push(this.state.genres.fulllist[i][j]);
            }
          }
        }
      } else genres.show = false;
      genres.picker = _new;
      this.setState({genres});
    }

    //if( event.target.name === "title" ) account.title = item;

    this.setState({account});
  }


  showPassword() {
		let password = this.state.password;
		password.visible = !password.visible;
		this.setState({password});
	}


  selectGenre(genre) {
    let genres = this.state.genres;
    genres.show = false;
    genres.value = '';
		for( let i in genres.picker ) if( genre === genres.picker[i] ) return;
		genres.picked.push(genre);
		this.setState({genres});
	}

	removeGenre(genre) {
		let genres = this.state.genres;
		for( let i in genres.picked ) if( genre === genres.picked[i] ) genres.picked.splice( i, 1 );
		this.setState({genres});
	}


  async submitChanges(type, event) {

    if( event ) event.preventDefault();
    let params = new URLSearchParams();
    params.append('id', this.state.account.id);
    switch( type ) {
      case 'level':
        params.append('id_level', this.state.account.id_level);
      break;
      case 'email':
        params.append('email', this.state.account.email);
      break;
      case 'password':
        params.append('pass1', document.getElementById('pass1').value);
        params.append('pass2', this.state.password.text);
      break;
      case 'title':
        params.append('title', this.state.account.title);
      break;
      case 'description':
        const outputData = await this.editorInstance.current.save();
        params.append('description', JSON.stringify(outputData.blocks));
      break;
      case 'country':
        params.append('country', typeof this.state.account.country === 'string'?this.state.account.country:this.state.account.country.join('/'));
      break;
      case 'genres':
        params.append('genres', JSON.stringify(this.state.genres.picked));
      break;
      case 'socials':
        params.append('socials', 'socials');
        let socials = this.state.socials;
        for( let i in socials ) {
          params.append(i, document.getElementById(i).value);
        }
      break;
      default:

      break;
    }
    const x = await putApi(`/v3/account/settings`, params);
    if( x.status === 200 ) {
      await this.retreiveAccount();
      if( type === 'password' ) {
        let password = this.state.password;
        password.changed = true;
        this.setState({password});
      }
    } else {
      if( type === 'password' ) {
        let password = this.state.password;
        password.error = x.data.message;
        this.setState({password});
      }
    }
  }
  
	render() {
    const user = this.context;
  

    const levels = this.state.levels.map((e,i) => {
      return (
        <option value={e.id} key={i} >{e.level}</option>
      )
    });
    

    /*const genres = this.state.account.genres.map((e, i) => {
      return (
        <div key={i}>{e}</div>
      )
    })*/

    const genrelist = Object.keys(this.state.genres.picker).map((e,i) => {
      return (
        <React.Fragment key={i}>
          <div><p>{e}</p></div>
          <div style={{marginLeft: -5}}>
            {(() => {
              return Object.keys(this.state.genres.picker[e]).map((f,j) => {
                return (
                  <Button key={j} className="btn btn-sm btn-info my-1 me-2" onClick={()=>this.selectGenre(this.state.genres.picker[e][f])}>{this.state.genres.picker[e][f]}</Button>
                )
              })
            })()}
          </div>
          <div style={{clear: 'both', paddingBottom: 10}}></div>
        </React.Fragment>
      )
    })
    const genrepicked = this.state.genres.picked.map((e,i) => {
      return (
        <Button key={i} size="sm" className="btn btn-teal-gradient btn-wave waves-effect waves-light">{e}
          <OverlayTrigger placement="top" key="overlay-5" overlay={<Tooltip id="tooltip5">Remove Genre</Tooltip>}>
            <span className="badge ms-2 bg-white text-primary" onClick={()=>this.removeGenre(e)}><FontAwesomeIcon icon="xmark" /></span>
          </OverlayTrigger>
          
        </Button>
      )
    })
    const socials = Object.keys(this.state.socials).map((e,i) => {
      return (
        <li key={i}>
          <div className="row mb-2">
            <label htmlFor={e} className="col-sm-2 col-form-label">{this.state.socials[e].name}</label>
            <div className="col-sm-10">
              <input type="text" className="form-control" name={e} id={e} placeholder={this.state.socials[e].placeholder} defaultValue={this.state.account[e]} />
            </div>
          </div>
        </li>
      )
    })

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Profile</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/profile/${this.state.account.username}`}>Profile</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
    
              <div className="row">
                <div className="col-xxl-12 col-xl-12">
                  <div className="card custom-card overflow-hidden">
                    <div className="card-body d-sm-flex align-items-top p-4   main-profile-cover">
                      <p className="avatar avatar-xxl avatar-rounded online me-3 my-auto">
                        {user.user?.user?.id === this.state.account.id ?
                          <UploadFile src={user.user.user.avatar.replace('/images/','')} path={`profile/${user.user.user.id}/`} onChange={this.changeAvatar}/>
                        :
                          <img src={`https://cloud.ultrastream.io${this.state.account.avatar}`} width="100%" alt="User Avatar" />
                        }
                      </p>
                      <div className="flex-fill main-profile-info my-auto">
                        <h5 className="fw-semibold mb-1 ">
                          {this.state.account.title?this.state.account.title:this.state.account.username}
                        </h5>
                        <div>
                          {this.state.account.radios &&
                            <p className="mb-1 text-muted">{this.state.account.radios}</p>
                          }
													{this.state.account.country &&
                            <div className="fs-12 op-7 mb-0 d-flex">
															{typeof this.state.account.country === "string" ?
                                <p className="me-3 mb-0"><FontAwesomeIcon icon="building" /> {this.state.account.country}</p>
															:
                                <>
                                    <p className="me-3 mb-0"><FontAwesomeIcon icon="building" /> {this.state.account.country[1]}</p>
                                    <p className="mb-0"><FontAwesomeIcon icon="location-dot" /> {this.state.account.country[0]}</p>
                                </>
															}
                            </div>
                          }
                        </div>
                      </div>
                      <div className="main-profile-info ms-auto">
                        <div className="">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex mb-0 ms-auto">
                              <div className="me-4">
                                <p className="fw-bold fs-20  text-shadow mb-0">0</p>
                                <p className="mb-0 fs-12 text-muted ">Followers</p>
                              </div>
                              <div className="">
                                <p className="fw-bold fs-20  text-shadow mb-0">0</p>
                                <p className="mb-0 fs-12 text-muted ">Following</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-0  mt-2 text-end">
                          <Link to={`/profile/${this.state.account.username}`}><button type="button" className="btn btn-primary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="home" /> Profile</button></Link>&nbsp;
                          <button type="button" className="btn btn-secondary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="plus" /> Follow</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-3">
                  <div className="card custom-card">
                    <div className="">
                      {typeof this.state.account.profile === 'number' &&
                        <div className="p-4 border-bottom border-block-end-dashed">
                          <div>
                            <p className="fs-15 mb-2 fw-semibold">Profile Status :</p>
                            <p className="fw-semibold mb-2">Profile {this.state.account.profile}% completed - <Link to="/settings" className="text-primary fs-12">Finish now</Link></p>
                            <div className="progress progress-sm progress-animate ">
                              <div className="progress-bar bg-primary  ronded-1" role="progressbar" aria-valuenow={this.state.account.profile} aria-valuemin="0" aria-valuemax="100" style={{width: `${this.state.account.profile}%`}}></div>
                            </div>
                          </div>
                        </div>
                      }
                      {this.state.account.description &&
                        <div className="p-4 border-bottom border-block-end-dashed">
                          <div className="">
                            <p className="fs-15 mb-2 fw-semibold">Professional Bio :</p>
                            <Blocks blocks={this.state.account.description} />
                          </div>
                        </div>
                      }
                      <div className="p-4  border-bottom border-block-end-dashed">
                        <p className="fs-15 mb-2 me-4 fw-semibold">Personal Info :</p>
                        <ul className="list-group">
                          {this.state.account.fullname &&
                            <li className="list-group-item border-0">
                              <div className="d-flex flex-wrap align-items-center">
                                <div className="me-2 fw-semibold"> Name : </div> <span className="fs-12 text-muted">{this.state.account.fullname}</span>
                              </div>
                            </li>
                          }
                          <li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Joined : </div> <span className="fs-12 text-muted">{moment(this.state.account.joined).format("Do MMM YYYY")}</span>
                            </div>
                          </li>
                          <li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Online : </div> <span className="fs-12 text-muted">{moment(this.state.account.lastconnect).format("Do MMM YYYY")}</span>
                            </div>
                          </li>
                          {/*<li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Designation : </div> <span className="fs-12 text-muted">C.E.O</span>
                            </div>
                          </li>
                          <li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Age : </div> <span className="fs-12 text-muted">28</span>
                            </div>
                          </li>
                          <li className="list-group-item border-0">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="me-2 fw-semibold"> Experience : </div> <span className="fs-12 text-muted">10 Years</span>
                            </div>
                          </li>*/}
                        </ul>
                      </div>
                      {this.state.account.genres?.length > 0 &&
                        <div className="p-4 border-bottom border-block-end-dashed">
                          <p className="fs-15 mb-2 me-4 fw-semibold">Genres :</p>
                          <Genres genres={this.state.account.genres} />
                        </div>
                      }
                      <div className="p-4 border-bottom border-block-end-dashed">
                          <p className="fs-15 mb-2 me-4 fw-semibold">Social Networks :</p>
                          <div className="btn-list mb-0">
                            {Object.keys(this.state.account).length>0&&<Socials user={this.state.account} />}
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-9 col-xl-12">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className=" custom-card">
                        <div className="card-body p-0">
													<Tab.Container id="left-tabs-example" defaultActiveKey="Account">
														<Row>
															<Col sm={12}>
																<Nav variant="pills" className="border-block-end-dashed  bg-white rounded-2 p-2" fill>
																	<Nav.Item >
																		<Nav.Link eventKey="Account">Account</Nav.Link>
																	</Nav.Item>
																	<Nav.Item>
																		<Nav.Link eventKey="Radio">Radio</Nav.Link>
																	</Nav.Item>
                                  <Nav.Item>
																		<Nav.Link eventKey="2FA">2FA</Nav.Link>
																	</Nav.Item>
																	<Nav.Item>
																		<Nav.Link eventKey="Devices">Devices</Nav.Link>
																	</Nav.Item>
																</Nav>
															</Col>
															<Col sm={12} className="py-4">
																<Tab.Content>

                                  <Tab.Pane eventKey="Account" className="p-0">
                                    {Object.values(this.state.account).length > 0 &&
                                      <>
                                        {user.user.admin && this.state.account.id_level &&
                                          <div className="card custom-card rounded-3">
                                            <div className="card-header">
                                              <div className="card-title">
                                                Change Level
                                              </div>
                                            </div>
                                            <div className="card-body">
                                              <Form>
                                                <ul className="list-unstyled">
                                                  <li>
                                                    <div className="row mb-2">
                                                      <label className="col-sm-2 col-form-label">Level</label>
                                                      <div className="col-sm-10">
                                                        <select className="form-select" name="level" aria-label="Default select example" defaultValue={this.state.account.id_level} onChange={this.handleChange}>
                                                          {levels}
                                                        </select>
                                                      </div>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="row mb-2">
                                                      <label className="col-sm-2 col-form-label"></label>
                                                      <div className="col-sm-10">
                                                        <Button size="sm" onClick={()=>this.submitChanges('level')}>Change Level</Button>
                                                      </div>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </Form>
                                            </div>
                                          </div>
                                        }
                                        <div className="card custom-card rounded-3">
                                          <div className="card-header">
                                            <div className="card-title">
                                              Change Email
                                            </div>
                                          </div>
                                          <div className="card-body">
                                            <Form onSubmit={(e)=>this.submitChanges('email',e)}>
                                              <ul className="list-unstyled">
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="email" className="col-sm-2 col-form-label">Email</label>
                                                    <div className="col-sm-10">
                                                      <input type="email" className="form-control" name="email" id="email" value={this.state.account.email} onChange={this.handleChange} />
                                                    </div>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"></label>
                                                    <div className="col-sm-10">
                                                      <Button size="sm" onClick={()=>this.submitChanges('email')}>Change Email</Button>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </Form>
                                          </div>
                                        </div>
                                        <div className="card custom-card rounded-3">
                                          <div className="card-header">
                                            <div className="card-title">
                                              Change Password
                                            </div>
                                          </div>
                                          <div className="card-body">
                                            <Form onSubmit={(e)=>this.submitChanges('password',e)}>
                                              <ul className="list-unstyled">
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="pass1" className="col-sm-2 col-form-label">Current Password</label>
                                                    <div className="col-sm-10">
                                                      <input type="password" className="form-control" id="pass1" name="pass1" autoComplete="new-password" required />
                                                    </div>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="pass2" className="col-sm-2 col-form-label">New Password</label>
                                                    <div className="col-sm-10">
                                                      <div className="input-group">
                                                        <input type={this.state.password.visible?'text':'password'} className="form-control" id="pass2" name="pass2" onChange={this.handleChange} value={this.state.password.text} autoComplete="new-password" required />
                                                        <button className="btn btn-light bg-transparent" type="button" onClick={this.showPassword} id="button-addon2"><FontAwesomeIcon icon={this.state.password.visible===true?'eye':'eye-slash'} /> <i className="ri-eye-off-line align-middle"></i></button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="pass2" className="col-sm-2 col-form-label">Status:</label>
                                                    <div className="col-sm-10">
                                                      {this.state.password.changed === true ?
                                                        <>
                                                          <span className="badge rounded-pill bg-success-gradient p-1"><FontAwesomeIcon icon="check" style={{color: '#ffffff'}} /></span> Password changed!
                                                        </>
                                                      :
                                                        <>
                                                          {this.state.password.text.length===0 &&
                                                            <>Requires 8 to 40 characters, Capital, Number and a Special character</>
                                                          }
                                                          {this.state.password.valid===true&&this.state.password.text.length>0&&<>&nbsp;<span className="badge rounded-pill bg-success-gradient p-1"><FontAwesomeIcon icon="check" style={{color: '#ffffff'}} /></span></>}
                                                          {this.state.password.valid === false && this.state.password.text.length > 0 &&
                                                            <label htmlFor="password" className="form-label text-secondary fw-semibold">&nbsp;* {this.state.password.error}</label>
                                                          }
                                                        </>
                                                      }
                                                    </div>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label className="col-sm-2 col-form-label"></label>
                                                    <div className="col-sm-10">
                                                      <Button size="sm" onClick={()=>this.submitChanges('password')} /*disabled={!this.state.password.valid}*/>Change Password</Button>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </Form>
                                          </div>
                                        </div>
                                      </>
                                    }
																	</Tab.Pane>

																	<Tab.Pane eventKey="Radio" className="p-0">
                                    {Object.values(this.state.account).length > 0 &&
                                      <>
                                      
                                        <div className="card custom-card rounded-3">
                                          <div className="card-header">
                                            <div className="card-title">
                                              Display Name
                                            </div>
                                          </div>
                                          <div className="card-body">
                                            <Form onSubmit={(e)=>this.submitChanges('title',e)}>
                                              <ul className="list-unstyled">
                                                <li>
                                                  <p>
                                                    You can alter your username by entering a display name:
                                                  </p>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="title" className="col-sm-2 col-form-label">Display Name</label>
                                                    <div className="col-sm-10">
                                                      <input type="text" className="form-control" name="title" id="title" value={this.state.account.title} onChange={this.handleChange} placeholder={this.state.account.username} />
                                                    </div>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label className="col-sm-2 col-form-label"></label>
                                                    <div className="col-sm-10">
                                                      <Button size="sm" onClick={()=>this.submitChanges('title')}>Change Display Name</Button>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </Form>
                                          </div>
                                        </div>
                                        <div className="card custom-card rounded-3">
                                          <div className="card-header">
                                            <div className="card-title">
                                              Professional Bio
                                            </div>
                                          </div>
                                          <div className="card-body">
                                            <Form onSubmit={(e)=>this.submitChanges('description',e)}>
                                              <ul className="list-unstyled">
                                                <li>
                                                  <p>
                                                    Write a professional bio about yourself and we'll include this when uploading to mixcloud/youtube:
                                                  </p>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="description" className="col-sm-2 col-form-label">Professional Bio</label>
                                                    <div className="col-sm-10 ">
                                                      <div className="form-control form-control-sm">
                                                        <ReactEditorJS
                                                          /*tools={Raw}*/
                                                          onInitialize={instance => (this.editorInstance.current = instance)}
                                                          data={{blocks: (this.state.account.description&&this.state.account.description.length>0)?JSON.parse(this.state.account.description):[]}}
                                                        />
                                                    </div>
                                                    </div>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"></label>
                                                    <div className="col-sm-10">
                                                      <Button size="sm" onClick={()=>this.submitChanges('description')}>Change Professional Bio</Button>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </Form>
                                          </div>
                                        </div>
                                        <div className="card custom-card rounded-3">
                                          <div className="card-header">
                                            <div className="card-title">
                                              Location
                                            </div>
                                          </div>
                                          <div className="card-body">
                                            <Form onSubmit={(e)=>this.submitChanges('country',e)}>
                                              <ul className="list-unstyled">
                                                <li>
                                                  <p>
                                                    Your location is determined from Maxmind GeoIP and the information provided might not be accurate, you may wish to set your own location and please seperate with a /
                                                  </p>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="country" className="col-sm-2 col-form-label">Location</label>
                                                    <div className="col-sm-10">
                                                      <input type="text" className="form-control" name="country" id="country" value={typeof this.state.account.country === 'string'?this.state.account.country:this.state.account.country.join('/')} onChange={this.handleChange} />
                                                    </div>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"></label>
                                                    <div className="col-sm-10">
                                                      <Button size="sm" onClick={()=>this.submitChanges('country')}>Change Location</Button>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </Form>
                                          </div>
                                        </div>
                                        <div className="card custom-card rounded-3">
                                          <div className="card-header">
                                            <div className="card-title">
                                              Genres
                                            </div>
                                          </div>
                                          <div className="card-body">
                                            <Form onSubmit={(e)=>this.submitChanges('genres',e)}>
                                              <ul className="list-unstyled">
                                                <li>
                                                  <p>
                                                    Set your default genres here and this will be reflected onto the schedule to give your fellow team members and the public to what type of music you play:
                                                  </p>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="genres" className="col-sm-2 col-form-label">Genres</label>
                                                    <div className="col-sm-10" style={{position: 'relative'}}>
                                                      <Form.Control type="text" name="genre" id="genre" value={this.state.genres.value} onChange={this.handleChange} className="form-control" placeholder="Search Genres" />
                                                      {this.state.genres.show === true &&
                                                        <div className="card card-body p-1" style={{position: 'absolute', top: 33, width: '96%', fontSize: 14, maxHeight: 250, overflowY: 'scroll', zIndex:1}}>
                                                          <div className="blockquote custom-blockquote info mb-0" style={{padding: 10}}>
                                                            {genrelist}
                                                          </div>
                                                        </div>
                                                      }
                                                      <div style={{fontSize:14, paddingTop: 5}}>
                                                        {genrepicked}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"></label>
                                                    <div className="col-sm-10">
                                                      <Button size="sm" onClick={()=>this.submitChanges('genres')}>Save Genres</Button>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </Form>
                                          </div>
                                        </div>
                                        <div className="card custom-card rounded-3">
                                          <div className="card-header">
                                            <div className="card-title">
                                              Socials
                                            </div>
                                          </div>
                                          <div className="card-body">
                                            <Form onSubmit={(e)=>this.submitChanges('socials',e)}>
                                              <ul className="list-unstyled">
                                                <li>
                                                  <p>
                                                    Please include your socials such as facebook and instagram for your followers to follow you:
                                                  </p>
                                                </li>
                                                {socials}
                                                <li>
                                                  <div className="row mb-2">
                                                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"></label>
                                                    <div className="col-sm-10">
                                                      <Button size="sm" onClick={()=>this.submitChanges('socials')}>Save Socials</Button>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </Form>
                                          </div>
                                        </div>
                                      </>
                                    }
																	</Tab.Pane>

                                  <Tab.Pane eventKey="2FA" className="p-0">
                                    <div className="card custom-card rounded-3">
                                      <div className="card-header">
                                        <div className="card-title">
                                          Two Factor Authentication
                                        </div>
                                      </div>
                                      <div className="card-body">
                                        <ul className="list-unstyled profile-timeline">
                                          <li> <span className="fs-12 text-muted fw-semibold text-end profile-timeline-time">22,Jan 2025</span>
                                            <div> <span className="avatar avatar-sm avatar-rounded profile-timeline-avatar"> <img src="../assets/images/faces/1.jpg" alt="" /> </span>
                                              <p className="text-muted mb-2"> <span className="text-default"><b>{this.state.account.title?this.state.account.title:this.state.account.username}</b> Shared project</span> </p>
                                              <p className="text-muted fs-12 mb-0">
                                                History of shows played will be listed here <br />
                                                This page not complete and please check back later
                                              </p>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
																	</Tab.Pane>

																	<Tab.Pane eventKey="Devices" className="p-0">
                                  <div className="card custom-card rounded-3">
                                      <div className="card-header">
                                        <div className="card-title">
                                          Two Factor Authentication
                                        </div>
                                      </div>
                                      <div className="card-body">
                                        <ul className="list-unstyled profile-timeline">
                                          <li> <span className="fs-12 text-muted fw-semibold text-end profile-timeline-time">22,Jan 2025</span>
                                            <div> <span className="avatar avatar-sm avatar-rounded profile-timeline-avatar"> <img src="../assets/images/faces/1.jpg" alt="" /> </span>
                                              <p className="text-muted mb-2"> <span className="text-default"><b>{this.state.account.title?this.state.account.title:this.state.account.username}</b> Shared project</span> </p>
                                              <p className="text-muted fs-12 mb-0">
                                                History of shows played will be listed here <br />
                                                This page not complete and please check back later
                                              </p>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
																	</Tab.Pane>

																</Tab.Content>
															</Col>
														</Row>
													</Tab.Container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
					</div>
				}
			</>
		);
	}
}

const Profile = props => {
  const { username } = useParams();
  return <PortalProfile username={username} {...props} />
}
export default Profile;